export default __webpack_public_path__ + "static/drone-20e35b700d29eecb81ac54f5676f7a28.jpeg";